import React from "react";
import AnimatedSection from "@/components/animation/AnimatedSection/AnimatedSection";
import WhatsAppFloatingButton from "@/components/WhatsAppFloatingButton";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import OptImg from "@/components/OptImg";

// Keep images & slugs here; pull all copy from i18n
const PRODUCTS = [
  {
    slug: "arcticstore",
    img: "https://res.cloudinary.com/dmvui9sur/image/upload/v1753458902/ArcticStore_Container_without_bg_gwre0q.png",
  },
  {
    slug: "ultrafreezer",
    img: "https://res.cloudinary.com/dmvui9sur/image/upload/v1753458896/Arcticstore_Ultrafreezer_without_bg_kcwxaq.png",
  },
  {
    slug: "arcticblast",
    img: "https://res.cloudinary.com/dmvui9sur/image/upload/v1753458926/Foto_ABF_40_v12pb9.png",
  },
  {
    slug: "arcticsuperstore",
    img: "https://res.cloudinary.com/dmvui9sur/image/upload/v1753458907/Arctic_SuperStore_yaacsr.png",
  },
];

const ProductSection = () => {
  const { t, i18n } = useTranslation("productsList");
  const lang = i18n.language === "id" ? "id" : "en";

  return (
    <section className="bg-white py-16 px-4 md:px-16">
      {/* Top: Title */}
      <div className="max-w-7xl mx-auto mb-14">
        <h1 className="text-[46px] md:text-[56px] font-bold text-[#101616] mb-2">
          {t("heading")}
        </h1>
        <p className="text-[20px] md:text-[22px] text-[#101616] opacity-80 max-w-3xl">
          {t("subheading")}
        </p>
      </div>

      {/* Product Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-14 gap-y-20 max-w-7xl mx-auto">
        {PRODUCTS.map((p, idx) => {
          const title = t(`items.${p.slug}.title`);
          const subtitle = t(`items.${p.slug}.subtitle`);
          const desc = t(`items.${p.slug}.desc`);
          return (
            <div
              key={p.slug}
              className="flex flex-col transition transform hover:-translate-y-2"
            >
              <div className="w-full flex justify-center">
                <OptImg
                  src={p.img}
                  alt={title}
                  className="w-full max-w-[400px] h-auto object-contain transition-transform duration-300 hover:scale-105 drop-shadow-xl"
                  priority={idx === 0}
                  draggable={false}
                />
              </div>
              <div className="flex flex-col mt-6 px-2">
                <div className="text-[28px] font-bold text-[#101616] mb-1">
                  {title}
                </div>
                <div className="text-lg font-semibold text-[#101616] mb-2 opacity-80">
                  {subtitle}
                </div>
                <div className="text-base text-[#101616] opacity-90 mb-4">
                  {desc}
                </div>
                <Link
                  to={`/${lang}/product/${p.slug}`}
                  className="w-fit bg-black text-white text-sm font-semibold py-2 px-4 rounded-full hover:opacity-80 transition"
                >
                  {t("cta")}
                </Link>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};
const InterestedSection = () => {
  const { t, i18n } = useTranslation(); // using ns in calls below
  const lang = i18n.language === "id" ? "id" : "en";

  return (
    <section className="w-full bg-gradient-to-tr from-[#e0ecff] to-[#f8fafc] py-10 px-4 sm:px-0 mb-8">
      <div className="max-w-2xl mx-auto flex flex-col items-center gap-4 text-center">
        <div className="text-2xl sm:text-3xl font-bold text-black mb-2">
          {t("common.ctaTitle", { ns: "services" })}
        </div>
        <div className="text-base sm:text-lg text-gray-700 mb-6">
          {t("common.ctaBody", { ns: "services" })}
        </div>
        <Link
          to={`/${lang}/get-started`}
          className="inline-flex items-center px-6 py-3 rounded-full bg-black text-white font-semibold text-lg shadow-md hover:bg-gray-800 focus:bg-gray-800 transition"
        >
          {t("common.ctaBtn", { ns: "services" })}
        </Link>
      </div>
    </section>
  );
};

const ProductPage = () => {
  return (
    <>
      <AnimatedSection>
        <ProductSection />
      </AnimatedSection>
      <AnimatedSection>
        <InterestedSection />
      </AnimatedSection>
      {/* <WhatsAppFloatingButton /> */}
    </>
  );
};

export default ProductPage;
